import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

const CONTACT_US_ENDPOINT = {
  sendContactUs: 'contact/submit-enquiry',
  sendDataAssistance: 'contact/data-assistance',
};

@Injectable({
  providedIn: 'root',
})
export class ContactUsService {
  constructor(private apiService: ApiService) {}

  sendContactUs(data: any) {
    return this.apiService.post(CONTACT_US_ENDPOINT.sendContactUs, data);
  }

  sendDataAssistance(data: FormData) {
    return this.apiService.post(CONTACT_US_ENDPOINT.sendDataAssistance, data);
  }
}
